import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import React, { useEffect, useState, useRef, useContext } from "react";
import { AppDB } from "../App";
import TextInput from "./TextInput";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { eventService } from "../services/EventService";
import { lookupsService } from "../services/LookupsService";
import { Toolbar } from "primereact/toolbar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatDate } from "../config/Config";
import { votersService } from "../services/VotersService";
import AddEvent from "../componets/AddEvent";
import AddEventDelimitationStaff from "../componets/AddEventDelimitationStaff";
import EditByElection from "../componets/EditByElection";
import ScreenLoader from "./ScreenLoader";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { permissionLookUp } from "../constants";

export default function ByElection({
	eventGroupId,
	selectedEvent = null,
	eventGroup = null,
	setData = [],
	buttonIcon = "pi pi-save",
	show = false,
	setShow,
	eventTypes
}) {
	var [byElectionEvents, setByElectionEvents] = useState([]);
	var [showEventDelimitationStaffForm, setShowEventDelimitationStaffForm] = useState(false);
	var [showSearchElector, setShowSearchElector] = useState(false);
	var [loading, setLoading] = useState(false);
	var [selectedByEvent, setSelectedByEvent] = useState({});
	var [showByElectionEditEvent, setShowByElectionEditEvent] = useState(false);
	const [reason, setReason] = useState("");
	const [byElectionData, setbyElectionData] = useState(null);
	const { toast, permission } = useContext(AppDB);

	const [showAddEventForm, setshowAddEventForm] = useState(false);
	useEffect(() => {
		GetAllEvents();
	}, [showAddEventForm]);

	async function GetAllEvents() {
		await eventService
			.getAllEvents({
				ParentEventID: selectedEvent?.eventID,
				DelimitationID: selectedEvent?.eventDelimitationId,
				DelimitationLeveID: selectedEvent?.eventDelimitationLevelId,
				IsByElection: true,
				PageIndex: 1,
				PageSize: 10000
			})
			.then((response) => {
				if (Array.isArray(response)) {
					setByElectionEvents(response);
				} else {
					setByElectionEvents([]);
				}
			})
			.catch((err) => {
				console.log(err);
				setByElectionEvents([]); // Handle errors gracefully
			});
	}

	const confirmDeleteEvent = (e) => {
		confirmDialog({
			message: "Are you sure you want to deactivate this item?",
			header: "Deactivate Event",
			icon: "pi pi-exclamation-triangle",
			accept: () => DeactivateEvent(e),
			reject: () => { }
		});
	};
	function DeactivateEvent(e) {
		eventService.DeActivateByElection(e?.eventID)
			.then((res) => {
				setLoading(false);
				console.log(res);
				if (res.success) {
					GetAllEvents();
				}
				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((error) => {
				setLoading(false);
				console.error("Error deactivating event:", error);
			});
	}
	return (
		<div>
			<ScreenLoader visible={loading} />
			<Dialog
				visible={showByElectionEditEvent}
				onHide={() => setShowByElectionEditEvent(false)}
				header="By-Election Details"
				modal
				style={{ width: "100%", height: "100%" }}
			>
				<EditByElection
					show={showByElectionEditEvent}
					setShow={setShowByElectionEditEvent}
					selectedEvent={selectedByEvent}
					selectedParantEvent={selectedEvent}
					eventGroupId={eventGroupId}
					IsByElection={true}
					GetAllEvents={GetAllEvents}
				/>
			</Dialog>
			<Dialog
				visible={showAddEventForm}
				onHide={() => setshowAddEventForm(false)}
				header="Event Details"
				modal
				style={{ width: "100%", height: "100%" }}
			>
				<AddEvent
					showAddEvent={showAddEventForm}
					setShowAddEvent={setshowAddEventForm}
					selectedEvent={selectedEvent}
					eventGroupId={eventGroupId}
					IsByElection={true}
					setByElectionEvents={setByElectionEvents}
					byElectionEvents={byElectionEvents}
					IsOneDemarcationEvent = {true}
				/>
			</Dialog>
			<Dialog
				draggable={false}
				header={
					<>
						<span>By Election: {selectedEvent?.name}</span>
					</>
				}
				footer={
					<>
						<Button
							label="Close"
							onClick={() => {
								setShow(false);
							}}
							className="p-button-danger"
							type="submit"
						/>
					</>
				}
				visible={show}
				onHide={(e) => setShow(false)}
				style={{ width: "100%", height: "100%" }}
			>
				<div className="grid my-2">
					<div className="col-12 lg:col-12">
						{permission?.subModules?.ByElectionEvent?.includes(permissionLookUp.Create) &&

							<Toolbar
								right={
									<>
										<Button
											className="p-button-success mr-2"
											icon="pi pi-plus"
											label="Add By-Election Event"
											onClick={(e) => setshowAddEventForm(true)}
										/>
									</>
								}
							/>
						}
						<DataTable
							className="remove-border my-2"
							size="small"
							scrollable={true}
							value={byElectionEvents}
							paginator
							rows={5}
							rowsPerPageOptions={[5, 10, 25]}
							dataKey="eventID"
							style={{ width: "100%" }}
						>
							<Column style={{ width: "250px" }} header="Event" field="name" sortable></Column>
							<Column style={{ width: "250px" }} header="Type" field="eventTypeName" sortable></Column>
							<Column style={{ width: "250px" }} header="Description" field="description" sortable></Column>
							<Column
								style={{ width: "250px" }}
								field="isActive"
								header="Status"
								sortable
								body={(e) => {
									return (
										<Button
											label={e.isActive == 1 ? "Active" : "Not Active"}
											style={{ height: "30px" }}
											className={`p-button-rounded  ${e.isActive == 1 ? "p-button-success" : "p-button-danger"}`}
										/>
									);
								}}
							/>

							<Column
								style={{ width: "250px" }}
								header="Actions"
								body={(e) => (
									<div className="flex gap-1">
										{permission?.subModules?.ByElectionEvent?.includes(permissionLookUp.Update) &&

											<Button
												type="button"
												icon="pi pi-pencil"
												severity="success"
												rounded
												tooltip="Click to Edit"
												onClick={() => {
													setSelectedByEvent(e);
													setShowByElectionEditEvent(true);
												}}
											/>
										}
										{permission?.subModules?.ByElectionEvent?.includes(permissionLookUp.Delete) &&

											<Button
												type="button"
												icon="pi pi-times"
												severity="danger"
												rounded
												tooltip="Click to Deactivate Event"
												onClick={() => {
													confirmDeleteEvent(e);
												}}
											/>}
									</div>

								)}
							></Column>
						</DataTable>
					</div>
				</div>
			</Dialog>
		</div>
	);
}
